import { useNotificationStore } from '@/stores/notifications';
import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ResetPasswordForm } from '../components/ResetPasswordForm';
import { Layout } from '../components/Layout';
import { PasswordChange } from '../components/PasswordChangeMsg';

export const PasswordSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  useEffect(() => {}, [navigate]);

  return (
    <Layout title="Register your account">
      <PasswordChange />
    </Layout>
  );
};
